<template>
    <span>
        <i class="fas fa-ellipsis-h fs-largest ml-2 dark pointer" @click.stop="toggleList"></i>
        <ul v-if="listOpen" @click="closeList" v-click-outside="closeList" class="actions position-absolute bg-lightest border-medium shadowed">
            <li v-for="item in items" class="fs-small" @click="selectItem(item)" v-tooltip.left="{content: item.toolTip, delay: {show: 1000, hide: 1000}, classes: ['dark']}">
                <div>
                    {{item.label}}
                </div>
            </li>
        </ul>
    </span>
</template>

<script>
export default {
    data: function () {
        return {
            listOpen: false
        }
    },
    props: {
        items: {
            type: Array,
            default: []
        }
    },
    methods: {
        openList: function () {
            this.listOpen = true
        },
        closeList: function () {
            this.listOpen = false
        },
        toggleList: function () {
            this.listOpen = !this.listOpen
        },
        selectItem: function (item) {
            this.$emit('input', item)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../assets/scss/_variables';

    .actions{
        right: 0;
        top: 110%;
        z-index: 5;
        width: 180px;

        li{
            cursor: pointer;
            padding: 15px 0;
            border-bottom: $medium solid 1px;
            margin: 0 15px;

            &:last-child{
                border-bottom: none;
            }

            &:hover{
                // background: $dark;
                // color: $lightest;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// threeDots.vue?60befcf2